import { v4 as uuidv4 } from 'uuid'

/**
 * Generate a secure share token for challenge sharing
 * Format: 8 character alphanumeric string (easier to share)
 */
export function generateShareToken(): string {
  // Generate a UUID and take first 8 characters, remove hyphens
  const uuid = uuidv4().replace(/-/g, '')
  return uuid.substring(0, 8).toLowerCase()
}

/**
 * Validate share token format
 */
export function isValidShareToken(token: string): boolean {
  if (!token || typeof token !== 'string') {
    return false
  }
  
  // Should be 8 alphanumeric characters
  return /^[a-z0-9]{8}$/.test(token.toLowerCase())
}

/**
 * Generate share URL for a challenge
 */
export function generateShareUrl(token: string, baseUrl?: string): string {
  const base = baseUrl || window.location.origin
  return `${base}/join/${token}`
}

/**
 * Extract share token from URL
 */
export function extractTokenFromUrl(url: string): string | null {
  const match = url.match(/\/join\/([a-z0-9]{8})/)
  return match ? match[1] : null
} 